/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2015 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by all applicable intellectual property
 * laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/

/**
 * Simple singleton style container so all logging related stuff has
 * a centeralized wrapper.
 */
var iaw = iaw || { };

iaw.log = {

	/**
	 * Boolean flag to globally enable/disable logging.
	 */
	enabled: true,

	/**
	 * Default log prefix.
	 */
	kLogPrefix: 'CCX-Start',

	/**
	 * Send a message to the log. An optional prefix can be passed which will get
	 * prepended to the message.
	 *
	 * @param msg           string object containing the log message
	 * @param optParam      optional object containing either a string to prepend
	 *                      to the message or an object containing multiple display
	 *                      options. the format is:
	 *                          { prefix: 'string', indent: number, alert: true, trace: false }
	 */
	console : function(msg, optParam) {

		var kIndentation = '     ';
		var prefix       = '';
		var depth        = 0;
		var trace        = false;

		// parse out the optional parameters
		if (typeof optParam === 'object') {
			prefix  = (optParam.prefix) ? ' - ' + optParam.prefix   : prefix;
			depth   = (optParam.indent) ? optParam.indent           : depth;
			trace   = (optParam.trace) ? optParam.trace             : trace;
		}
		else if (typeof optParam === 'string') {
			prefix =  ' - ' + optParam;
		}

		// build up the default message
		var logmsg = this.kLogPrefix+prefix+' :: ';

		// add indentation if requested
		for (; depth > 0; depth--) { logmsg += kIndentation; }
		logmsg += msg;

		// dump to the log file
		console.log(logmsg);
		// dump the stack so we know what happened
		if (trace) console.trace();
	},

	/**
	 * Dumps a JavaScript object out to the log. An optional prefix can be passed which will get
	 * prepended to the message.  This only works in the Chrome debugger.
	 *
	 * @param msg           string object containing the log message
	 * @param prefix        optional object containing a string to prepend to the message
	 */
	dump : function(obj, prefix) {

		console.log('<< '+this.kLogPrefix+' >> object: '+ ((prefix) ? prefix + ' - %o' : '%o'), obj);
	},

	/**
	 * Shortcut to add a debugging prefixed message to the log.
	 *
	 * @param msg           string object containing the log message
	 */
	debug : function(msg) {

		this.console(msg, 'DEBUG');
	},

	/**
	 * Place a separator message in the log.
	 */
	separator : function() {

		console.log(this.kLogPrefix + '==========================================================');
	},

	/**
	 * Send a separated message out to the log . An optional prefix can be passed which
	 * will get prepended to the message.
	 *
	 * @param msg           string object containing the log message
	 * @param prefix        optional object containing a string to prepend to the message
	 */
	mark : function(msg, prefix) {

		this.separator();
		this.console('@'+Date()+' '+msg, prefix);
	},

	/**
	 * Dumps out an options structure to the log.
	 *
	 * @param msg           string object containing the log message
	 * @param obj           object to output
	 * @param step          indentation step for recursive call
	 */
	logObject : function(msg, obj, step) {

		this.console(msg);
		step = (typeof step !== 'undefined') ? step : 1;

		// walk throug the object
		if (typeof obj !== 'undefined' && obj !== null) {
			var otype = null;

			switch (typeof obj) {
				case 'object':
					for (var member in obj) {
						otype = typeof obj[member];
						this.console(member +' = '+obj[member]+' ('+otype+')', { indent: step });
					}
					break;

				// process array
				case 'array': {
					var arraylen = obj.length;

					for (var idx = 0; idx < arraylen; idx++) {
						otype = typeof obj[idx];
						this.console('array['+idx+']= '+obj[idx]+' ('+otype+')', { indent: step });
					}
					break;
				}

				default: // atomic type
					this.console('('+typeof obj+') : '+obj, { indent: step });
					break;
			}
		}
	},

	/**
	 * Dumps out a JSON object structure to the log.
	 *
	 * @param msg           string object containing the log message
	 * @param jsonData      string or object containing the JSON
	 */
	logJSON : function(msg, jsonData) {

		if (window.__adobe_cep__) {
			// CEP log changed and \n is not supported so
			// makes the data more difficult to read
			this.console(msg+' '+JSON.stringify(jsonData));
		}
		else {
			this.console(msg+'\n'+JSON.stringify(jsonData, null, 4));
		}
	},

	/**
	 * Dumps out a JSON object structure to the log.
	 *
	 * @param msg           string object containing the log message
	 * @param jsonData      string or object containing the JSON
	 */
	logJSONDelayed: function(msg, jsonData) {
		setTimeout(function() {
			iaw.log.logJSON(msg, jsonData);
		}, 1000);
	},

	/**
	 * Send an error object to the log. The error contains a message and a call stack list
	 *
	 * @param e             error object containing the exceptions
	 */
	exception : function(e) {
		console.trace();
		console.error(this.kLogPrefix+' EXCEPTION! '+ e.stack);
	}
};
